<template lang="pug">
div
  ValidationObserver(ref="dialogObserver")
    AppDialog.vue-time-entries-delete-dialog(
      title="Delete time"
      append-to-body
      :show="show"
      @close="close"
    )
      template(slot="corner")
        a.dialog-faq-link(
          target="_blank"
          rel="noopener noreferrer"
          title="Read the help article about this feature"
          href="https://support.hubstaff.com/how-to-add-delete-and-edit-manual-time-entries/"
        ) ?

      TimeEntriesTimeEntryInfo(:time-entry="timeEntry")
      form.simple_form.time_entry_form.form-horizontal
      .row
        .col-xs-12
          TimeEntriesDifferentTimeZoneWarning(:datetime-range="datetimeRange")
      .row.form-group
        .col-xs-12
          TimeEntriesTextarea(
            v-model="note"
            name="note"
            label="Reason"
            placeholder="Why are you deleting this time entry? (ex: Forgot to stop timer)"
            :required="reasonRequiredForTimeEntry"
          )

      template(slot="footer")
        button.btn.btn-default(@click="close") Cancel
        button.btn.btn-danger(
          type="submit"
          :disabled="saving || checking"
          @click="save"
        )
          | {{ saveButtonLabel }}
  // Confirmation dialog for unlocking time
  TimeEntriesOverrideDialog(
    :show.sync="showOverrideDialog"
    type="delete"
    :time-entry="timeEntry"
    @submit="save"
    @close="handleOverrideCancel"
  )
</template>

<script>
import { mapGetters } from 'vuex';
import { TimeEntryOverrideApprovedTimesheet } from '~/mixins';

export default {
  name: 'TimeEntriesDeleteDialog',
  mixins: [TimeEntryOverrideApprovedTimesheet],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    onDelete: {
      type: Function,
      default: null,
    },
    timeEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showOverrideDialog: false,
      datetimeRange: {},
      saving: false,
      checking: false,
      note: '',
      requestTimeEntryId: null,
      errorMessage: 'There was an error when updating this time entry',
      successMessage: 'Time entry deleted',
    };
  },
  computed: {
    ...mapGetters(['user', 'getProject', 'organizationId']),
    project() {
      return this.getProject(this.timeEntry.project_id);
    },
    reasonRequiredForTimeEntry() {
      return this.project && this.project.reason_required;
    },
    saveButtonLabel() {
      return this.saving ? 'Deleting...' : 'Delete';
    },
    timeEntryParams() {
      return {
        organization_id: this.organizationId,
        time_entry: {
          note: this.note,
        },
      };
    },
  },
  watch: {
    show: function (value) {
      if (value) {
        this.reset();
      }
    },
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      this.userId = this.user.id;
      this.setStartStopDatetime(this.timeEntry.start_time, this.timeEntry.stop_time);
      this.projectId = this.timeEntry.project_id;
      this.taskId = this.timeEntry.task_id;
      this.note = '';
      this.requestTimeEntryId = this.timeEntry.id;
      this.timesheetRedirectUrl = null;
      this.previousValidationToken = null;
      this.previousRequestTimeEntryId = null;
      this.checkForCollisions();
    },
    setStartStopDatetime(startDatetime, stopDatetime) {
      this.datetimeRange = { start: startDatetime, stop: stopDatetime };
    },
    checkForCollisions() {
      if (this.projectId) {
        const params = this.timeEntryParams;
        const success = (response) => {
          this.checking = false; // enable the save button after checking
          if (response.alert) {
            this.$appMessage(response.alert);
          } else {
            this.validationToken = response.validation_token;
            this.requestTimeEntryId = response.validation_token || this.timeEntry.id;
            this.check = response;
          }
        };

        this.checking = true; // disable the save button while checking
        this.$store
          .dispatch('checkTimeEntry', { id: this.timeEntry.id, params })
          .then(success)
          .catch(() => {});
      }
    },
    async save() {
      const isValid = await this.$refs.dialogObserver.validate();

      if (isValid) {
        const success = this.success;
        const error = () => this.$appMessage(this.errorMessage);
        const fin = () => {
          this.saving = false;
        };
        const params = Object.assign(this.timeEntryParams, { validation_token: this.validationToken });

        this.saving = true;
        this.$store
          .dispatch('deleteTimeEntry', {
            id: this.requestTimeEntryId || this.timeEntry.id,
            params,
          })
          .then(success, error)
          .then(fin);
      }
    },
    success(response) {
      if (response.action === 'confirm-override') {
        this.$store.dispatch('assignAssociatedRecords', {
          id: this.timeEntry.id,
          associatedRecords: response.associated_records,
        });
        this.previousValidationToken = this.validationToken;
        this.previousRequestTimeEntryId = this.requestTimeEntryId;
        this.validationToken = response.validation_token;
        this.requestTimeEntryId = response.validation_token || this.timeEntry.id;
        this.timesheetRedirectUrl = response.timesheet_redirect_url;
        this.showOverrideDialog = true;
      } else if (response.action === 'error-response') {
        const errors = response.errors;

        this.$refs.dialogObserver.setErrors(errors);
        this.$appMessage(response.alert);
      } else {
        this.$appMessage(this.successMessage);

        if (this.onDelete && !this.timesheetRedirectUrl) {
          this.onDelete();
          this.close();

          return;
        }

        this.handleSuccessfulAction();
      }
    },
    close() {
      this.$refs.dialogObserver?.reset?.();
      this.$emit('close');
    },
  },
};
</script>
